import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { IMobileWebParams } from 'tag/ts/tag/interfaces/config/mobileweb/IMobileWebParams';

/**
 * @copyright © Paramount Streaming
 * @description Tag-layer Mobile Web config module.
 *
 * Provides copy strings and other Mobile Web-specific defaults consumed by the
 * `MobileWebUI` Tag-level plugin's display injectors (e.g. `ReplayOverlayInjector`, see
 * `plugins/tag/plugin_mobile_web_ui/`). Extend IMobileWebParams as new Mobile Web surface
 * areas are added.
 */
export const TagConfigMobileWeb = {
	category: ConfigModuleCategory.COPY,
	enabled: true,
	params: {
		copy: {
			replay: 'Replay'
		}
	} as IMobileWebParams
};